import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { urlPreviewQuery } from 'networking/mindfeed/queries/urlPreview';
import { OgObject } from 'networking/mindfeed/types/OgObject';

export default function useUrlPreview(
  targetUrl: string,
  enabled: boolean,
): UseQueryResult<OgObject, Error> {
  return useQuery({ ...urlPreviewQuery(targetUrl), enabled });
}
